import {PointLike, Point} from "maplibre-gl";

export const requirePoint = (pointLike: PointLike): Point =>
{
    if(pointLike instanceof Point){
        return pointLike;
    }
    return new Point(pointLike[0], pointLike[1]);
}